import { ISubscription } from 'models/subscriptions.model'

import { APPLOVIN_ARTS_AND_ENTERTAINMENT_CATEGORY_ID } from 'root-constants'

import { getAppConfigMap } from './getAppConfigMap'

type TAxonItem = {
  item_id: string
  item_variant_id: string
  item_name: string
  price: number
  quantity: number
  image_url: string
}

export const getAxonItem = (subscriptions: ISubscription[]): TAxonItem[] => {
  const { appConfig } = getAppConfigMap()

  return subscriptions.map(({ id, mainPrices, trialPrices }) => ({
    item_id: `${id}`,
    item_variant_id: `${id}`,
    item_category_id: APPLOVIN_ARTS_AND_ENTERTAINMENT_CATEGORY_ID,
    item_name: `${mainPrices.periodQuantity} ${mainPrices.periodName} plan`,
    price: trialPrices?.fullPrice || mainPrices.fullPrice,
    image_url: appConfig.logoUrl,
    quantity: 1,
  }))
}
